module.exports = __webpack_public_path__ + "static/media/likeStar.a2a80406.png";